export default __webpack_public_path__ + "static/media/star-fill-gray5-16.f60cfadd.svg";